import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { IoCContainer, IWebCoreSettings } from '@lmnop/web-core';
import { AngularCoreIoCKeys, IAngularCoreIoCContainer } from 'angular-core-src';
import { AbstractModalBase } from '../abstract-modal-base/abstract-modal-base.component';

@Component({
    template: '',
    selector: 'angular-core-modal-base',
})
export abstract class ModalBase extends AbstractModalBase {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
        this.ioc = IoCContainer.get(AngularCoreIoCKeys.IAngularCoreIoCContainer);
        this.settings = this.ioc.settings;
    }

    protected ioc: IAngularCoreIoCContainer;
    protected settings: IWebCoreSettings;
}
